import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_WORKSPACE_PRODUCT: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateWorkspaceProduct($input: UpdateWorkspaceProductInput!) {
    updateWorkspaceProduct(input: $input) {
      workspaceProduct {
        id
        product
        performanceReportUrl
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
